import { gsap } from "gsap";
import { Text } from "pixi.js";

import { DDDWildTTF } from "../../../assetsLoader/DDDAssetsNames";
import { symbolConfig } from "../../../config/DDDConfig";
import { DDDSymbolNames } from "../../../types/DDDEnums";
import { DDDSymbol } from "./DDDSymbol";
import { symbolsResizeConfig } from "./DDDSymbolsResizeConfig";

export class DDDWildSymbol extends DDDSymbol {
    protected multiplierText: Text;
    protected multiplier: { value: number } = { value: 0 };

    constructor() {
        super(DDDSymbolNames.WILD);
        this.isWild = true;
    }

    protected generateSymbol(): void {
        super.generateSymbol();

        this.multiplierText = new Text(`X${1}`, {
            fontFamily: DDDWildTTF.FAMILY,
            fontSize: `38px`,
            dropShadow: true,
            dropShadowAlpha: 0.8,
            dropShadowBlur: 0.8,
            dropShadowColor: 0x000000,
            dropShadowDistance: 1,
            fill: `#ffffff`,
            stroke: `#000000`,
            strokeThickness: 1,
            lineJoin: `round`,
        });

        this.multiplierText.name = `multiplierText`;
    }

    private alignSymbol(): void {
        this.mainSpine.x =
            symbolConfig.symbolWidth / 2 +
            symbolsResizeConfig.get(this.name as DDDSymbolNames)!.default.offsetX!;
        this.mainSpine.y =
            symbolConfig.symbolHeight / 2 +
            symbolsResizeConfig.get(this.name as DDDSymbolNames)!.default.offsetY!;
    }

    public override getLandingAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return this.mainSpine.getSpineTween(`landing`, false, null, null, () => {
            this.mainSpine.getSpineTween(`Normal`);
        });
    }

    public getWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return this.mainSpine.getSpineTween(`Win`, false, () => {
            this.alpha = 1;
        });
    }

    // public getNoWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
    //     return this.mainSpine.getSpineTween(`NoWin`);
    // }

    // public getNoWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
    //     return gsap.to(this, {
    //         alpha: 0.25,
    //         duration: 0.5,
    //     });
    // }

    public getMultiplierAnimation(wildsCounter: number): gsap.core.Tween | gsap.core.Timeline {
        if (wildsCounter === 1) {
            return gsap.timeline();
        }

        this.multiplierText.text = `X${Math.round(wildsCounter)}`;
        this.multiplier.value = wildsCounter;
        this.multiplierText.scale.set(1.2);
        this.multiplierText.alpha = 0;
        this.multiplierText.x = 43;
        this.multiplierText.y = 103;

        const animation = gsap.to(this.multiplierText, {
            alpha: 1,
            duration: 0.15,
            ease: `power1.in`,
            pixi: { scale: 1, y: 115 },
            onUpdate: () => {
                this.multiplierText.text = `x${Math.round(this.multiplier.value)}`;
            },
            onStart: () => {
                this.addChild(this.multiplierText);
            },
        });

        return animation;
    }

    protected override resetMainSpine(isSpin: boolean = false) {
        if (this.mainSpine !== undefined) {
            if (!isSpin) {
                this.multiplier.value = 0;
                this.mainSpine.removeChild(this.multiplierText);

                this.removeChild(this.mainSpine);

                this.mainSpine.getSpineTween(`Normal`);

                this.alignSymbol();

                this.mainSpine.mask = null;
                this.mainSpine.scale.set(0.5);

                this.mainSpine.x =
                    symbolConfig.symbolWidth / 2 +
                    symbolsResizeConfig.get(this.name as DDDSymbolNames)!.default.offsetX!;
                this.mainSpine.y =
                    symbolConfig.symbolHeight / 2 +
                    symbolsResizeConfig.get(this.name as DDDSymbolNames)!.default.offsetY!;
            } else {
                gsap.killTweensOf(this.mainSpine);
            }

            this.addChild(this.mainSpine);

            if (this.multiplier.value > 1) {
                this.addChild(this.multiplierText);
            }
        }
    }

    public override reset() {
        super.reset();

        this.multiplier.value = 0;
        this.removeChild(this.multiplierText);
        this.isWild = true;
    }
}
